// Modules
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';

// Rxjs
import { filter, Observable, Subject } from 'rxjs';

// Store - Reducer
import { AppState } from '@store/reducers';
// Store - Actions
import * as AuthActions from '@store/actions/auth.actions';
// Store - Selectors
import * as AuthSelectors from '@store/selectors/auth.selectors';
// Enum - Credential type
import { authCredentialType } from '@shared/enums/authCredentialType';

// Components
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  EventMessage,
  EventType,
  InteractionStatus,
} from '@azure/msal-browser';
import { IMSTokenLogin } from '@app/general/shared/interfaces';

//Services
import { AppConfigService } from '@app/modules/shared/services/app-config/app-config.service';

@Component({
    selector: 'sbi-cot-back-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  // Public variables
  public credentialTypeEnum = authCredentialType;
  public currentCredentialType: number = this.credentialTypeEnum.EMAIL;
  public credentialDropdownOpened: boolean = false;

  // Public selectors
  public signingIn$: Observable<boolean> = this._store.pipe(
    select(AuthSelectors.selectSigningInStatus)
  );

  public loginFailed$: Observable<boolean> = this._store.pipe(
    select(AuthSelectors.selectLoginFailed)
  );
  public passwordRecovered$: Observable<boolean> = this._store.pipe(
    select(AuthSelectors.selectPasswordRecoveredStatus)
  );

  public logged: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  // Constructor
  constructor(
    private _store: Store<AppState>,
    private _authMsalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private _app: AppConfigService
  ) {}

  // On component init
  ngOnInit() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        console.log(result);
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  setLoginDisplay() {
    this.logged = this._authMsalService.instance.getAllAccounts().length > 0;
    if (this.logged) this.getToken();
  }

  getToken() {
    const account = this._authMsalService.instance.getAllAccounts();
    this._authMsalService
      .acquireTokenSilent({
        account: account[0],
        scopes: [`api://${this._app.microsoft365.clientId}/token`],
      })
      .subscribe(res => {
        if (res) {
          const payload: IMSTokenLogin = {
            email: res.account.username,
            accessToken: res.accessToken,
          };
          this._store.dispatch(
            AuthActions.loginMSTokenRequested({
              payload: payload,
            })
          );
        }
      });
  }

  // Public method to try an user login
  public onUserLogin(): void {
    this._store.dispatch(AuthActions.loginMicrosoftRequested());
  }
}
